<template>
  <div class="top">
    <div class="content">
      <div class="tip-seat">
        <div class="tip-left">
          <img src="../assets/images/logo.png" alt="" />
        </div>
        <div class="tip-wrap">
          <div
            class="tip-item"
            :class="tipIndex == index ? 'tip-item-click' : ''"
            v-for="(item, index) in tipList"
            :key="index"
            @click="tipClick(index, item)"
            @mouseover="tipMouseover(index)"
          >
            {{ item.projectTypeName }}
            <div class="tip-item-line"></div>
            <div class="tip-li" v-show="!item.children.length == 0">
              <li
                class="item-li"
                v-for="(item2, index2) in item.children"
                :key="index2"
                @click="tipItemClick(index, item, index2)"
              >
                {{ item2.projectTypeName }}
              </li>
            </div>
          </div>
        </div>
        <!-- <img
          @click="showSearch = true"
          src="../assets/images/search1.png"
          alt=""
        /> -->
        <a style="color:blue;font-size: 16px;text-decoration: underline;" target="_blank"
          href="https://b2b.baidu.com/aitf/shop?name=%E5%A8%B2%E7%9F%B3%E6%B0%B4%E6%B3%A5%E9%9B%86%E5%9B%A2%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8&tpath=index"
          >商城</a
        >
        <div class="phone">Tel：027-8696 4298</div>
      </div>
    </div>
    <div class="search" v-show="showSearch" @mouseleave="showSearch = false">
      <div class="search-bottom">
        <div class="search-l">
          <el-input
            v-model="searchInput"
            placeholder="请输入搜索内容"
          ></el-input>
        </div>
        <div class="search-r" @click="getInput()">
          <i class="el-icon-search" style="font-size: 30px"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTProjectTypeListByIndex } from "@/api/api.js";
export default {
  name: "detailsTop",
  props: ["topIndex", "isHomeProps"],
  data() {
    return {
      tipList: [],
      tipIndex: 0,
      isHome: false,
      showSearch: false,
      searchInput: "",
    };
  },
  created() {
    this.tipIndex = this.topIndex;
    this.isHome = this.isHomeProps;
    this.getTipList();
  },
  methods: {
    async getTipList() {
      const { data } = await getTProjectTypeListByIndex();
      if (data.code === 200) {
        this.tipList = data.data;
        this.tipList = this.tipList.splice(0, 7);
      }
    },
    goHome() {
      this.$router.push({
        name: "Home",
      });
    },
    tipClick(index, row) {
      if (index === 0) {
        this.isHome = true;
        this.$router.push({
          name: "Home",
          // query: { topIndex: index }
        });
      }
    },
    tipMouseover(index) {},
    tipItemClick(index, row, index2) {
      this.tipIndex = index;
      if (index === 0) {
        this.isHome = true;
        this.$router.push({
          name: "Home",
        });
      } else {
        this.isHome = false;
      }
      if (index === 1) {
        this.$router.push({
          name: "news",
          query: { topIndex: index },
        });
      }
      if (index === 2) {
        this.$router.push({
          name: "exhibition",
          query: { topIndex: index },
        });
      }
      if (index === 3) {
        this.$router.push({
          name: "news3",
          query: { topIndex: index },
        });
      }
      if (index === 4) {
        this.$router.push({
          name: "news4",
          query: { topIndex: index },
        });
      }
      if (index === 5) {
        this.$router.push({
          name: "news5",
          query: { topIndex: index },
        });
      }
      // if (index === 6) {
      //   this.$router.push({
      //     name: "news6",
      //     query: { topIndex: index },
      //   });
      // }
      // if (index === 7) {
      //   this.$router.push({
      //     name: "exhibition",
      //     query: { topIndex: index },
      //   });
      // }
      // if (index === 6) {
      //   if (index2 === 0) {
      //     this.$router.push({
      //       name: "contactUS",
      //       query: { topIndex: index },
      //     });
      //   }
      //   if (index2 === 1) {
      //     this.$router.push({
      //       name: "aftersales",
      //       query: { topIndex: index },
      //     });
      //   }
      //   if (index2 === 2) {
      //     this.$router.push({
      //       name: "support",
      //       query: { topIndex: index },
      //     });
      //   }
      //   if (index2 === 3) {
      //     this.$router.push({
      //       name: "join",
      //       query: { topIndex: index },
      //     });
      //   }
      //   if (index2 === 4) {
      //     this.$router.push({
      //       name: "message",
      //       query: { topIndex: index },
      //     });
      //   }
      // }
      this.$emit("bannerIndex", index2);
      // localStorage.removeItem('lobannerIndex')
      localStorage.setItem("bannerList", JSON.stringify(row.children));
      localStorage.setItem("lobannerIndex", index2);
    },
    getInput() {
      const routeUrl = this.$router.resolve({
        path: "/publicList",
        query: { type: "search", search: this.searchInput },
      });
      window.open(routeUrl.href, "_blank");
      this.searchInput = "";
    },
  },
};
</script>

<style scoped lang="less">
* {
  padding: 0;
  margin: 0;
  background-color: #ffffff;
}
.top {
  width: 100%;
  height: 90px;
  background-color: #fff;
  position: sticky;
  top: 0;
  left: 0;
  z-index: 10000;
}
.content {
  width: 86%;
  max-width: 1440px;
  margin: 0 auto;
  height: 90px;

  .tip-seat {
    height: 90px;
    line-height: 90px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .tip-left {
      width: 150px;
      height: 43px;
      display: flex;
      align-items: center;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .tip-wrap {
      flex: 1;
      width: 70%;
      padding: 0 5%;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;

      .tip-item {
        width: 100px;
        font-size: 16px;
        color: #191919;
        cursor: pointer;
        height: 90px;
      }

      .tip-item-click {
        color: #185da0;
        font-size: 16px;
        box-sizing: border-box;
        border-bottom: 3px solid #2a5e90;
      }

      .tip-item:hover {
        font-weight: 600;
      }

      .tip-item:hover li {
        display: block;
      }

      .tip-item:hover .tip-li {
        display: block;
        border: 1px solid #2a5e90;
      }

      .tip-li {
        display: none;
        background: #86a9c8;
        border-radius: 10px;
        overflow: hidden;
        position: relative;
        top: -20px;
      }

      .item-li {
        height: 50px;
        line-height: 50px;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        display: none;
        // background: rgba(177, 216, 250, 0.4);
      }

      .item-li:hover {
        background: #2a5e90;
        color: #fff;
      }
    }

    .tip-right {
      height: 35px;
      cursor: pointer;

      .el-icon-search {
        display: block;
        width: 100%;
        height: 100%;
      }
    }

    .phone {
      width: 228px;
      height: 90px;
      font-family: Adobe Heiti Std;
      font-size: 18px;
      color: #ffffff;
      line-height: 90px;
      background: #46739f;
      margin-left: 30px;
    }
  }
}

.search {
  width: 100%;
  height: 200px;
  padding-top: 50px;
  box-sizing: border-box;
  position: absolute;
  box-shadow: 0px 3px 14px rgba(0, 0, 0, 0.2) inset;
  z-index: -1;

  .search-bottom {
    width: 50%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    border-bottom: 2px solid #333333;
    justify-content: space-between;

    .search-l {
      width: 90%;

      /deep/ .el-input__inner {
        border: none !important;
        background: none !important;
      }
    }

    .search-r {
      cursor: pointer;
    }
  }
}
</style>
